import React from 'react';
import clsx from 'clsx';
import { useCustomComponent } from '@/hooks';

export interface TypingIndicatorContainerProps {
  className?: string;
  children: React.ReactNode;
}

const ContainerComponent: React.FC<TypingIndicatorContainerProps> = ({
  className,
  children,
}) => {
  return (
    <div className={clsx('peptalk-typing-indicator', className)}>
      {children}
    </div>
  );
};

export const Container: React.FC<TypingIndicatorContainerProps> = (
  props: TypingIndicatorContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'TypingIndicatorContainer',
    Component: ContainerComponent,
  });

  return <Component {...props} />;
};
